import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaGithub, FaLinkedin, FaEnvelope, FaInstagram, FaDownload, FaChevronRight, FaArrowRight,
} from "react-icons/fa";

const SOCIALS = [
  { icon: FaGithub,    href: "https://github.com/aayam17",                           label: "GitHub"    },
  { icon: FaLinkedin,  href: "https://np.linkedin.com/in/aayam-bhattarai-1ba53b343", label: "LinkedIn"  },
  { icon: FaInstagram, href: "https://www.instagram.com/aayambhattarai_/",           label: "Instagram" },
  { icon: FaEnvelope,  href: "mailto:aayambht@gmail.com",                            label: "Email"     },
];

export default function Footer({ onSwitch, hideCta }) {
  return (
    <footer className="nx-foot">
      <div className="nx-foot-in">

        {!hideCta && (
        <section className="nx-cta" aria-labelledby="nx-cta-h">
          <div>
            <h2 id="nx-cta-h">Ready to start your next project?</h2>
            <p>Open to new roles and freelance work. Let's talk.</p>
          </div>
          <div className="nx-cta-b">
            <Link className="nx-btn nx-btn-r" to="/contact">Get in touch <FaChevronRight /></Link>
            <a className="nx-btn nx-btn-g" href="/Aayam_Bhattarai_CV.pdf" download="Aayam_Bhattarai_CV.pdf">
              <FaDownload /> Download CV
            </a>
          </div>
        </section>
        )}

        <div className="nx-fgrid">
          <div className="nx-fbrand">
            <Link to="/" className="nx-logo">AAYAM</Link>
            <p>Frontend developer from Bhaktapur, Nepal.</p>
            <a className="nx-mail" href="mailto:aayambht@gmail.com">
              <span className="nx-mail-ic"><FaEnvelope /></span>
              <span className="nx-mail-tx">
                <small>Questions?</small>
                <b>aayambht@gmail.com</b>
              </span>
              <FaArrowRight className="nx-mail-ar" aria-hidden="true" />
            </a>
            <div className="nx-soc">
              {SOCIALS.map(({ icon: Icon, href, label }) => (
                <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}><Icon /></a>
              ))}
            </div>
          </div>

          <nav className="nx-fnav" aria-label="Footer">
            <div className="nx-fcol">
              <h3>Explore</h3>
              <ul className="nx-flinks">
                <li><NavLink to="/" end>Home</NavLink></li>
                <li><NavLink to="/projects">Projects</NavLink></li>
                <li><NavLink to="/contact">Contact</NavLink></li>
              </ul>
            </div>
            <div className="nx-fcol">
              <h3>Connect</h3>
              <ul className="nx-flinks">
                <li><a href="mailto:aayambht@gmail.com">Email me</a></li>
                <li><a href="https://wa.me/9779849610810" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
              </ul>
            </div>
            <div className="nx-fcol">
              <h3>Profile</h3>
              <ul className="nx-flinks">
                {onSwitch && <li><button type="button" onClick={onSwitch}>Switch profile</button></li>}
                <li><button type="button" onClick={() => window.scrollTo(0, 0)}>Back to top</button></li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="nx-fbot">
          <p className="nx-copy">© {new Date().getFullYear()} Aayam Bhattarai · Bhaktapur, Nepal · Made in Nepal</p>
          <p className="nx-copy">Design inspired by streaming interfaces. Not affiliated with or endorsed by Netflix, Inc.</p>
        </div>

      </div>
    </footer>
  );
}
